import log from 'salvo-lite/log'

class CurrencyForm {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._form = elem.querySelector('form')
        this._select = elem.querySelector('select')
        this._data = JSON.parse(elem.getAttribute('data-currency-form'))
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        if (this._data.currency === 'GBP') {
            let firstOption = this._select.querySelector('option')
            firstOption.click()
            this._form.submit()
        }
        this._select.addEventListener('change', e => {
            console.log('change')
            this._form.submit()
        })
    }
}

export default CurrencyForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CurrencyForm.js